import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const useUserId = () => {
  const { userId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userId) {
      navigate("/");
    }
  }, [navigate, userId]);

  return userId!;
};
